import React, { Component } from 'react';
import { compose } from 'redux';
import ServiceCreate from '../../components/Providers/ServiceCreate';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import { FormattedMessage } from 'react-intl';

export class Create extends Component {
    componentDidMount() {
        this.props.allCategoryAction();
    }
    render() {
        const { categoryData } = this.props;
        return (
            <div className="tz-2-com tz-2-main">
                <h4>
                    <FormattedMessage
                        id="addNewItem"
                        defaultMessage="Add New Item"
                    />
                </h4>
                <div className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <ServiceCreate
                                {...this.props}
                                categoryData={categoryData}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ categories, settings, auth }) => {
    return {
        categoryData: categories.categoryData,
        categoryLoader: categories.categoryLoader,
        settings: settings,
        userData: auth.userData
    };
};
const composedComponent = compose(
    connect(
        mapStateToProps,
        actions
    )
);
export default composedComponent(Create);



// WEBPACK FOOTER //
// ./src/views/ProviderService/Create.jsx